module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6LjmI"))).then(() => parcelRequire('1iHdE'));